import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var Root = styled.div.withConfig({
  displayName: "ui-kit-Root",
  componentId: "ui-kit-iwe92n"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  z-index: ", ";\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  \n  &.hidden {\n    visibility: hidden;\n  }\n\n  &.absolute {\n    position: absolute;\n  }\n"], ["\n  position: fixed;\n  z-index: ", ";\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  \n  &.hidden {\n    visibility: hidden;\n  }\n\n  &.absolute {\n    position: absolute;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.zIndex.modal;
});
var templateObject_1;